module.exports = __webpack_public_path__ + "img/close.15ac2457.svg";